import { FOfferType } from '@/packages/JsonQuery';

import { type IBuildingClassOption } from '../types';

import { COMMON_BUILDING_CLASS_OPTIONS, OFFICE_BUILDING_CLASS_OPTIONS } from './constants';

export function getBuildingClassList(offerType: FOfferType): IBuildingClassOption[] {
  if (offerType === FOfferType.Office) {
    return OFFICE_BUILDING_CLASS_OPTIONS;
  } else {
    return COMMON_BUILDING_CLASS_OPTIONS;
  }
}
